import { Link, createFileRoute } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";

import { DisposicionSitio } from "@/components/medam/sitio";
import { Button } from "@/components/ui/button";
import { LEYENDA_CONVOCATORIA } from "@/lib/catalogos";

export const Route = createFileRoute("/postulacion/confirmacion")({
  validateSearch: (search: Record<string, unknown>) => ({
    folio: typeof search["folio"] === "string" ? search["folio"] : "",
    posicion: typeof search["posicion"] === "string" ? search["posicion"] : "",
  }),
  head: () => ({
    meta: [
      { title: "Postulación recibida | MEDAM" },
      {
        name: "description",
        content: "Tu postulación fue registrada. Conserva tu folio para dar seguimiento.",
      },
      { property: "og:title", content: "Postulación recibida | MEDAM" },
      { property: "og:description", content: "Gracias por tu interés en formar parte de MEDAM." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: Confirmacion,
});

function Confirmacion() {
  const { folio, posicion } = Route.useSearch();

  return (
    <DisposicionSitio>
      <div className="mx-auto w-full max-w-2xl px-4 py-16 text-center sm:px-6">
        <CheckCircle2 className="mx-auto size-14 text-primary" aria-hidden="true" />
        <h1 className="mt-6 font-display text-3xl">¡Gracias por postularte!</h1>
        <p className="mt-3 text-muted-foreground">
          Hemos recibido tu postulación{posicion ? ` para la posición de ${posicion}` : ""}. Nuestro
          equipo revisará tu información y, si tu perfil corresponde con los requisitos, te
          contactaremos por los medios que registraste.
        </p>

        {folio ? (
          <div className="mt-8 rounded-2xl border border-primary/25 bg-secondary/50 p-6">
            <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground">
              Folio de seguimiento
            </p>
            <p className="mt-2 font-display text-2xl tracking-wide">{folio}</p>
            <p className="mt-2 text-xs text-muted-foreground">
              Conserva este folio para cualquier aclaración sobre tu postulación.
            </p>
          </div>
        ) : null}

        <p className="mt-8 text-xs leading-relaxed text-muted-foreground">
          {LEYENDA_CONVOCATORIA}
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button asChild variant="outline">
            <Link to="/">Volver al inicio</Link>
          </Button>
          <Button asChild>
            <Link to="/posiciones">Ver otras posiciones</Link>
          </Button>
        </div>
      </div>
    </DisposicionSitio>
  );
}
